import React, { useState } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { StyleShowcase } from './components/StyleShowcase';
import { ValueStrip } from './components/ValueStrip';
import { ProcessSection } from './components/ProcessSection';
import { FaqSection } from './components/FaqSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
import { FloatingWhatsApp } from './components/FloatingWhatsApp';
import { MobilePreview } from './components/MobilePreview';
export function App() {
  const [isMobilePreviewOpen, setIsMobilePreviewOpen] = useState(false);
  const isMobilePreview = new URLSearchParams(window.location.search).has('mobile-preview');
  return <div className="w-full overflow-x-hidden bg-warm font-sans text-ink" data-id="element-0" data-mp="2wi5n7ieqknpb">
      <Header data-id="element-1" data-mp="28suveqfd63nb" />
      <main data-id="element-2" data-mp="28sbbx5a2f776">
        <Hero data-id="element-3" data-mp="28s30zixi6bym" />
        <StyleShowcase data-id="element-4" data-mp="23vkuoemiy5k6" />
        <ValueStrip onMobilePreview={isMobilePreview ? undefined : () => setIsMobilePreviewOpen(true)} data-id="element-5" data-mp="23u9tmmkgrbwr" />
        <ProcessSection data-id="element-6" data-mp="3iiwg8rrbto4t" />
        <FaqSection data-id="element-7" data-mp="3ijpd910hgz9r" />
        <FinalCtaSection data-id="element-8" data-mp="3ii4qhxkeukmg" />
      </main>
      <Footer data-id="element-9" data-mp="3mkrcviybbdc9" />
      <FloatingWhatsApp data-id="element-10" data-mp="3mk852v2dm5by" />
      {isMobilePreviewOpen && <MobilePreview onClose={() => setIsMobilePreviewOpen(false)} data-id="element-11" data-mp="3rc9dg5wfbbwp" />}
    </div>;
}